import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { DrawSVGPlugin } from '../greensock/DrawSVGPlugin';
import { CountUp } from 'countup.js';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);

const MEALS_COUNT = 924298;
const options = {
    duration: 1,
};

export function FourScene() {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.fourth-section',
            start: 'top top',
            end: '100%',
            scrub: 1,
            invalidateOnRefresh: true
        }
    });

    tl.to('.fourth-section__text-block', 5, { y: '-=80vh' });
    tl.to('.fourth-section', 1, { opacity: 0, zIndex: 'auto' });
    tl
        .set('.fifth-section', { 'pointer-events': 'auto', zIndex: 4 })
        .set('#statistics-background circle', { drawSVG: '0% 0%' })
        .fromTo('.fifth-section__box', 3, { autoAlpha: 0, scale: 1.2 }, { autoAlpha: 1, scale: 1 })
        .fromTo('.fifth-section__info-wrapper', 1, {
            autoAlpha: 0, y: '30vh'
        }, {
            autoAlpha: 1, y: 0
        }, '-=0.5');

    var rawCounts = $('.fifth-section__counter').attr('numbers').split(',');
    var counts = [];
    for (var i = 0; i < rawCounts.length; i++) {
        counts.push(parseInt(rawCounts[i]));
    }

    var descriptionContainer = $('.fifth-section__description');
    var descriptions = descriptionContainer.find('> span');
    var icons = $('.fifth-section__info-icon > span');
    var count = $('#counter');
    var previousCounter;
    var percent = 100 / counts.length;
    tl
        .set(descriptionContainer, { height: () => descriptions[0].clientHeight })
        .to(icons[0], { duration: 1, y: '-100%' }, '+=2')
        .to(descriptions[0], { duration: 1, y: '-100%' }, '-=.8')
        .to('.fifth-section__counter > span', 1, {
            y: '-100%',
            onStart: function () {
                if (previousCounter) {
                    previousCounter.pauseResume();
                }
                count.text(0);
            },
            onComplete: function () {
                previousCounter = new CountUp('counter', counts[0], options);
                previousCounter.start();
            },
            onReverseComplete: function () {
                count.text('0');
            }
        }, '-=.8')
        .fromTo('#statistics-background circle', 2, { drawSVG: '0%' }, { drawSVG: percent + '%' });
}